import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST,
  ACCENT_TERTIARY_LIGHT,
  NOTICE_LIGHTEST
} from "@streeteasy/design-system/colors";

export const theme = {
  noFee: {
    backgroundColor: `${ACCENT_PRIMARY_LIGHTEST}`
  },
  openHouse: {
    backgroundColor: `${NOTICE_LIGHTEST}`
  },
  priceDecrease: {
    backgroundColor: `${ACCENT_TERTIARY_LIGHT}`
  },
  priceIncrease: {
    backgroundColor: `${ACCENT_TERTIARY_LIGHT}`
  }
};

export const TagContainer = styled.div`
  background-color: ${props => theme[props.type].backgroundColor};
  border-radius: 100px;
  display: flex;
  height: 20px;
  margin: 2px 4px 0;
  padding: 0 16px;
`;

export const TagText = styled.p`
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
`;
